import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["appearance", "children", "tokens"],
    _excluded2 = ["focused", "selected", "tabIndex", "children", "selectedIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { AppearanceProvider, useAppearance } from '@segment/matcha/foundations/AppearanceContext';
import { CheckIcon } from '@segment/matcha/components/Icons/Common';
import * as MenuList from '@segment/matcha/components/MenuList';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Menu.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var externalAppearance = _ref.appearance,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var appearance = useAppearance(externalAppearance);
  return _jsx(views.Menu, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: _jsx(AppearanceProvider, {
      appearance: appearance,
      children: children
    })
  }));
});
export var Menu = withDesignTokens(BaseMenu, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300],
      backgroundColor: theme.palette.neutrals.white[100],
      shadow: theme.shadows[1],
      scrollbar: {
        trackColor: theme.palette.brand.darkAcai[100],
        thumbColor: theme.palette.brand.darkAcai[500]
      }
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[500],
      backgroundColor: theme.palette.brand.darkAcai[600],
      shadow: theme.shadows[1],
      scrollbar: {
        trackColor: theme.palette.brand.darkAcai[800],
        thumbColor: theme.palette.brand.darkAcai[400]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      backgroundColor: theme.palette.neutrals.white[100],
      scrollbar: {
        trackColor: theme.palette.twilio.gray[10],
        thumbColor: theme.palette.twilio.gray[60]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      backgroundColor: theme.palette.neutrals.white[100],
      scrollbar: {
        trackColor: theme.palette.twilio.gray[10],
        thumbColor: theme.palette.twilio.gray[60]
      }
    };
  }
});
export var Item = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var focused = _ref2.focused,
      selected = _ref2.selected,
      tabIndex = _ref2.tabIndex,
      children = _ref2.children,
      _ref2$selectedIcon = _ref2.selectedIcon,
      selectedIcon = _ref2$selectedIcon === void 0 ? _jsx(CheckIcon, {
    size: "small"
  }) : _ref2$selectedIcon,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(MenuList.Item, _objectSpread(_objectSpread({
    selectedIcon: selectedIcon,
    "aria-selected": selected,
    focused: focused,
    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : -1,
    selected: selected,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});